import { defineMessages } from 'react-intl';

export default defineMessages({
    dateCannotBePriorYearBuilt: {
        id: 'ml.policychange.discounts.Date entered cannot be prior to Year Built',
        defaultMessage: '{nameOfModifier}: Date entered cannot be prior to Year Built'
    },
    makeChanges: {
        id: 'ml.policychange.discounts.Make Changes',
        defaultMessage: 'Make Changes'
    },
    nextBaseDescription: {
        id: 'ml.policychange.discounts.nextBaseDescription',
        defaultMessage: 'We\'ll check if {bold} next'
    },
    nextDescriptionBold: {
        id: 'ml.policychange.discounts.nextDescriptionBold',
        defaultMessage: 'additional changes are needed'
    },
    syncingDiscounts: {
        id: 'ml.policychange.discounts.Syncing Discounts',
        defaultMessage: 'Syncing discounts...'
    },
    importantReminder: {
        id: 'ml.policychange.discounts.Important Reminder',
        defaultMessage: 'Important Reminder'
    },
    warningMessage: {
        id: 'ml.policychange.discounts.warningMessage',
        defaultMessage: '{importantReminder} {confirmEmailAddress}'
    },
    confirmEmailAddress: {
        id: 'ml.policychange.discounts.confirmEmailAddress',
        defaultMessage: 'Customer will receive email to validate Smart Home device at {email}. Confirm email address on Profile Details page.'
    },
    discounts: {
        id: 'ml.policychange.discounts.discounts',
        defaultMessage: 'Discounts'
    },
    updatedDiscounts: {
        id: 'ml.policychange.discounts.updatedDiscounts',
        defaultMessage: 'Updated Discounts'
    },
    dateCannotBeAfterTodaysDate: {
        id: 'ml.policychange.discounts.Date entered cannot be after todays date',
        defaultMessage: '{nameOfModifier}: Date entered cannot be after today\'s date'
    },
    tenantScreeningTooltip: {
        id: 'ml.policychange.discounts.tenantScreening Tooltip',
        defaultMessage:
            '<b>Credit check:</b> The landlord orders and reviews the tenant\'s credit report history.<br></br>' +
            '<br></br><b>Criminal background check:</b> The landlord orders a report the tenant\'s criminal record including prior convictions.<br></br>' +
            '<br></br><b>Eviction search:</b> The landlord orders a report of the prior tenant evictions.<br></br>' +
            '<br></br><b>HO4 tenant policy on file:</b> The landlord maintains a copy of the tenant\'s HO4 policy.<br></br>' +
            '<br></br><b>Skip search:</b> The landlord orders a report of the tenant\'s prior unfulfilled lease agreements.'
    },
    inValidOptionselected: {
        id: 'ml.policychange.discounts.Invalid Option selected',
        defaultMessage: '“None apply” cannot be selected with other options. Please update your selections.'
    },
    requiredDetailsMissingError: {
        id: 'ml.policychange.discounts.requiredDetailsMissingError',
        defaultMessage: 'Please provide all the required details'
    },
    defensibleSpaceLabel: {
        id: 'ml.policychange.discounts.Defensible Space',
        defaultMessage: 'Defensible Space'
    },
    defensibleSpaceUnavailableLabel: {
        id: `ml.policychange.discounts.Defensible Space data is not available for this property`,
        defaultMessage: `Defensible Space data is not available for this property`
    },
    tenantValueRequired: {
        id: `ml.policychange.discounts.TenantScreeningError`,
        defaultMessage: `Please provide the required information for the Tenant Screenings`
    }
});
